/* tslint:disable */

declare var Object: any;
export interface TtadleaverequestInterface {
  "requestNo": string;
  "companyId": number;
  "requestedby"?: string;
  "requestfor"?: string;
  "requestdate"?: Date;
  "leaveCode"?: string;
  "leaveStartdate"?: Date;
  "leaveEnddate"?: Date;
  "usecalendar"?: string;
  "totaldays"?: string;
  "remark"?: string;
  "approvalStatus"?: number;
  "createdBy": string;
  "createdDate": Date;
  "modifiedBy"?: string;
  "modifiedDate"?: Date;
  "refdoc"?: string;
  "reqfullday"?: string;
  "hdtypeStarttime"?: number;
  "hdtypeEndtime"?: number;
  tcltrequests?: any;
  ttadleaverequestdetails?: any[];
  type_leave?: any;
  request_for?: any;
  rel_cancel?: any[];
}

export class Ttadleaverequest implements TtadleaverequestInterface {
  "requestNo": string;
  "companyId": number;
  "requestedby": string;
  "requestfor": string;
  "requestdate": Date;
  "leaveCode": string;
  "leaveStartdate": Date;
  "leaveEnddate": Date;
  "usecalendar": string;
  "totaldays": string;
  "remark": string;
  "approvalStatus": number;
  "createdBy": string;
  "createdDate": Date;
  "modifiedBy": string;
  "modifiedDate": Date;
  "refdoc": string;
  "reqfullday": string;
  "hdtypeStarttime": number;
  "hdtypeEndtime": number;
  tcltrequests: any;
  ttadleaverequestdetails: any[];
  type_leave: any;
  request_for: any;
  rel_cancel: any[];
  constructor(data?: TtadleaverequestInterface) {
    Object.assign(this, data);
  }
  /**
   * The name of the model represented by this $resource,
   * i.e. `Ttadleaverequest`.
   */
  public static getModelName() {
    return "Ttadleaverequest";
  }
  /**
  * @method factory
  * @author Jonathan Casarrubias
  * @license MIT
  * This method creates an instance of Ttadleaverequest for dynamic purposes.
  **/
  public static factory(data: TtadleaverequestInterface): Ttadleaverequest{
    return new Ttadleaverequest(data);
  }
  /**
  * @method getModelDefinition
  * @author Julien Ledun
  * @license MIT
  * This method returns an object that represents some of the model
  * definitions.
  **/
  public static getModelDefinition() {
    return {
      name: 'Ttadleaverequest',
      plural: 'Ttadleaverequests',
      path: 'Ttadleaverequests',
      properties: {
        "requestNo": {
          name: 'requestNo',
          type: 'string'
        },
        "companyId": {
          name: 'companyId',
          type: 'number'
        },
        "requestedby": {
          name: 'requestedby',
          type: 'string'
        },
        "requestfor": {
          name: 'requestfor',
          type: 'string'
        },
        "requestdate": {
          name: 'requestdate',
          type: 'Date'
        },
        "leaveCode": {
          name: 'leaveCode',
          type: 'string'
        },
        "leaveStartdate": {
          name: 'leaveStartdate',
          type: 'Date'
        },
        "leaveEnddate": {
          name: 'leaveEnddate',
          type: 'Date'
        },
        "usecalendar": {
          name: 'usecalendar',
          type: 'string'
        },
        "totaldays": {
          name: 'totaldays',
          type: 'string'
        },
        "remark": {
          name: 'remark',
          type: 'string'
        },
        "approvalStatus": {
          name: 'approvalStatus',
          type: 'number'
        },
        "createdBy": {
          name: 'createdBy',
          type: 'string'
        },
        "createdDate": {
          name: 'createdDate',
          type: 'Date'
        },
        "modifiedBy": {
          name: 'modifiedBy',
          type: 'string'
        },
        "modifiedDate": {
          name: 'modifiedDate',
          type: 'Date'
        },
        "refdoc": {
          name: 'refdoc',
          type: 'string'
        },
        "reqfullday": {
          name: 'reqfullday',
          type: 'string'
        },
        "hdtypeStarttime": {
          name: 'hdtypeStarttime',
          type: 'number'
        },
        "hdtypeEndtime": {
          name: 'hdtypeEndtime',
          type: 'number'
        },
      },
      relations: {
        tcltrequests: {
          name: 'tcltrequests',
          type: 'any',
          model: ''
        },
        ttadleaverequestdetails: {
          name: 'ttadleaverequestdetails',
          type: 'any[]',
          model: ''
        },
        type_leave: {
          name: 'type_leave',
          type: 'any',
          model: ''
        },
        request_for: {
          name: 'request_for',
          type: 'any',
          model: ''
        },
        rel_cancel: {
          name: 'rel_cancel',
          type: 'any[]',
          model: ''
        },
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/shared/sdk/models/Ttadleaverequest.ts